/* eslint-disable max-statements */
import classNames from 'classnames';
import React from 'react';
import Categories from './Components/Categories';
import { CategoryKey } from './Components/Categories/config';
import ProjectPanel from './Components/ProjectPanel';
import icPlay from 'assets/svg/ic_play.svg';
import icFacebook from 'assets/svg/ic_facebook.svg';
import icTwitter from 'assets/svg/ic_twitter.svg';
import icTelegram from 'assets/svg/ic_telegram.svg';
import icDiscord from 'assets/svg/ic_discord.svg';
import icClose from 'assets/svg/ic_close_3.svg';
import PrivateSaleProvider from './Components/ProjectPanel/PrivateSaleProvider';
import { allowListStatusMap } from './config';
import styles from './styles.module.scss';
import { navigateToStaking } from 'src/utils/navigate';
import Button from 'src/Components/Button_V2';
import { useParams } from 'react-router-dom';
import { getPrivateSaleConfig, getProjectDetail, getUserProject, invalidateUserProject } from 'src/redux/actions';
import { useTypedDispatch, useTypedSelector } from 'src/redux/utils';
import { AppError } from 'src/redux/types';
import { formatCurrency } from '@wolffun/system-currency';
import dayjs from 'dayjs';
import PageContent from 'src/Components/PageContent';
import EmptyList from 'src/Components/EmptyList';
import Spinner from 'src/Components/Spinner';
import withScrollToTop from 'src/utils/withScrollToTop';
import UserWalletProvider from '@profile/src/Profile_V2/UserWalletProvider';
import Modal from 'src/Components/Modal';
import { sanitize } from 'src/utils/sanitize';
import BackButton from 'src/Components/BackButton';

const ProjectDetailPage = () => {
  const dispatch = useTypedDispatch();
  const params = useParams();
  const projectInfo = useTypedSelector(state => state.projectDetail.data);
  const userProject = useTypedSelector(state => state.userProject.data);
  const invalidated = useTypedSelector(state => state.projectDetail.invalidated);
  const loading = useTypedSelector(state => state.projectDetail.loading);
  const error = useTypedSelector(state => state.projectDetail.error);
  React.useEffect(() => {
    const fetch = async () => {
      await dispatch(getProjectDetail(params.id));
      dispatch(invalidateUserProject());
      await dispatch(getUserProject(params.id));
      dispatch(getPrivateSaleConfig());
    };

    fetch();
  }, [dispatch, params.id]);
  const allowListStatus = projectInfo ? allowListStatusMap[projectInfo.allowlistStatus] : undefined;
  const renderTokenSaleTab = React.useCallback(() => {
    if (!projectInfo) return undefined;
    const {
      initialMarketCap,
      initialTokenCirculation,
      saleEndTime,
      saleStartTime,
      tokenDistributionTime: tokenDistribution
    } = projectInfo.tokenSale;
    return projectInfo && /*#__PURE__*/React.createElement("div", {
      className: styles.table
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.row
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.name
    }, "Sale price"), /*#__PURE__*/React.createElement("span", {
      className: styles.value
    }, projectInfo.symbol ? `1 ${projectInfo.symbol} = $${formatCurrency(projectInfo.pricePerToken, {
      withCurrency: false,
      trimWholeFraction: true
    })}` : 'TBA')), /*#__PURE__*/React.createElement("div", {
      className: styles.row
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.name
    }, "Sale Start Time (UTC)"), /*#__PURE__*/React.createElement("span", {
      className: styles.value
    }, saleStartTime ? `${dayjs(saleStartTime).utc().format('MMMM DD YYYY[,] HH:mm')} UTC` : 'TBA')), /*#__PURE__*/React.createElement("div", {
      className: styles.row
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.name
    }, "Sale End Time (UTC)"), /*#__PURE__*/React.createElement("span", {
      className: styles.value
    }, saleEndTime ? `${dayjs(saleEndTime).utc().format('MMMM DD YYYY[,] HH:mm')} UTC` : 'TBA')), /*#__PURE__*/React.createElement("div", {
      className: styles.row
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.name
    }, "Token Distribution (UTC) "), /*#__PURE__*/React.createElement("span", {
      className: styles.value
    }, tokenDistribution ? `${dayjs(tokenDistribution).utc().format('MMMM DD YYYY[,] HH:mm')} UTC` : 'TBA')), /*#__PURE__*/React.createElement("div", {
      className: styles.row
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.name
    }, "Initial Market Cap "), /*#__PURE__*/React.createElement("span", {
      className: styles.value
    }, initialMarketCap ? `$${initialMarketCap.toLocaleString('en-US')}` : 'TBA')), /*#__PURE__*/React.createElement("div", {
      className: styles.row
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.name
    }, "Initial Token Circulation "), /*#__PURE__*/React.createElement("span", {
      className: styles.value
    }, initialTokenCirculation ? initialTokenCirculation.toLocaleString('en-US') : 'TBA')));
  }, [projectInfo]);
  const renderDescriptionTab = React.useCallback(() => projectInfo && /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.detail,
    dangerouslySetInnerHTML: {
      __html: sanitize(projectInfo.desc)
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.about
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.heading
  }, `About ${projectInfo.name}`), /*#__PURE__*/React.createElement("div", {
    className: styles.wrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.aboutDetail
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.footerTitle
  }, "Website:"), /*#__PURE__*/React.createElement("div", {
    className: styles.linkContainer
  }, /*#__PURE__*/React.createElement("a", {
    href: projectInfo.websiteUrl,
    title: projectInfo.websiteUrl,
    className: styles.link,
    target: "_blank",
    rel: "noreferrer"
  }, projectInfo.websiteUrl)), projectInfo.documentUrl && /*#__PURE__*/React.createElement("span", {
    className: styles.footerTitle
  }, "Document:"), projectInfo.documentUrl && /*#__PURE__*/React.createElement("div", {
    className: styles.linkContainer
  }, /*#__PURE__*/React.createElement("a", {
    href: projectInfo.documentUrl,
    title: "whitepaper",
    className: styles.link,
    target: "_blank",
    rel: "noreferrer"
  }, "Whitepaper"))), /*#__PURE__*/React.createElement("div", {
    className: styles.aboutDetail
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.footerTitle
  }, "Social Media:"), /*#__PURE__*/React.createElement("div", {
    className: styles.iconGroup
  }, projectInfo.facebookUrl && /*#__PURE__*/React.createElement("a", {
    href: projectInfo.facebookUrl,
    title: projectInfo.facebookUrl,
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/React.createElement("img", {
    className: styles.icon,
    src: icFacebook
  })), projectInfo.twitterUrl && /*#__PURE__*/React.createElement("a", {
    href: projectInfo.twitterUrl,
    title: projectInfo.twitterUrl,
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/React.createElement("img", {
    className: styles.icon,
    src: icTwitter
  })), projectInfo.discordUrl && /*#__PURE__*/React.createElement("a", {
    href: projectInfo.discordUrl,
    title: projectInfo.discordUrl,
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/React.createElement("img", {
    className: styles.icon,
    src: icDiscord
  })), projectInfo.telegramUrl && /*#__PURE__*/React.createElement("a", {
    href: projectInfo.telegramUrl,
    title: projectInfo.telegramUrl,
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/React.createElement("img", {
    className: styles.icon,
    src: icTelegram
  }))))))), [projectInfo]);
  const categories = React.useMemo(() => [{
    key: CategoryKey.Description,
    name: 'Description',
    renderCategory: renderDescriptionTab
  }, {
    key: CategoryKey.TokenSale,
    name: 'Token Sale',
    renderCategory: renderTokenSaleTab
  }], [renderDescriptionTab, renderTokenSaleTab]);
  const [selectedKey, setSelectedKey] = React.useState(CategoryKey.Description);
  const [selectedTab, setSelectedTab] = React.useState(categories.find(e => e.key === selectedKey));
  const [modalTutorialOpen, setModalTutorialOpen] = React.useState(false);
  React.useEffect(() => {
    const item = categories.find(e => e.key === selectedKey);
    setSelectedTab(item);
  }, [categories, selectedKey]);

  const renderError = () => /*#__PURE__*/React.createElement(EmptyList, null);

  const renderLoading = () => /*#__PURE__*/React.createElement(Spinner, null);

  const youtubeURL = useTypedSelector(state => state.privateSaleConfig.youtubeURL);

  const renderModalTutorial = () => {
    return /*#__PURE__*/React.createElement(Modal, {
      className: styles.modal
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
      className: styles.icClose,
      src: icClose,
      onClick: () => {
        setModalTutorialOpen(false);
      }
    }), /*#__PURE__*/React.createElement("iframe", {
      src: youtubeURL,
      title: "YouTube video player",
      frameBorder: "0",
      allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
      allowFullScreen: true
    })));
  };

  const renderContent = () => /*#__PURE__*/React.createElement(UserWalletProvider, null, /*#__PURE__*/React.createElement(PrivateSaleProvider, null, /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement(BackButton, {
    onClick: () => navigateToStaking(),
    className: styles.btn,
    label: "Back to Staking"
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.section
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.logoGroup
  }, /*#__PURE__*/React.createElement("img", {
    className: styles.logo,
    src: projectInfo === null || projectInfo === void 0 ? void 0 : projectInfo.logoUrl
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.titleContainer
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, projectInfo === null || projectInfo === void 0 ? void 0 : projectInfo.name), /*#__PURE__*/React.createElement("span", {
    className: styles.description
  }, projectInfo !== null && projectInfo !== void 0 && projectInfo.symbol ? `$${projectInfo === null || projectInfo === void 0 ? void 0 : projectInfo.symbol}` : 'TBA'))), /*#__PURE__*/React.createElement("div", {
    className: styles.btnGroup
  }, youtubeURL && /*#__PURE__*/React.createElement(Button, {
    className: styles.btn,
    type: "success",
    title: "Beginner Guide",
    onClick: () => {
      setModalTutorialOpen(true);
    },
    icon: icPlay
  }), modalTutorialOpen && renderModalTutorial(), allowListStatus && /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.status, allowListStatus.style)
  }, /*#__PURE__*/React.createElement("span", null, allowListStatus.text))))), /*#__PURE__*/React.createElement("div", {
    className: styles.projectDetail
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.projectInfo
  }, /*#__PURE__*/React.createElement("img", {
    className: styles.backgroundImg,
    src: projectInfo === null || projectInfo === void 0 ? void 0 : projectInfo.imageUrl
  }), /*#__PURE__*/React.createElement(Categories, {
    className: styles.category,
    data: categories,
    onClickItem: item => {
      setSelectedKey(item.key);
    },
    selectedKey: selectedKey
  }), selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.renderCategory()), projectInfo && /*#__PURE__*/React.createElement(ProjectPanel, {
    detail: projectInfo,
    userProject: userProject,
    className: styles.panel
  }))))));

  return /*#__PURE__*/React.createElement(PageContent, {
    renderContent: renderContent,
    renderError: renderError,
    renderLoading: renderLoading,
    error: error !== AppError.NO_ERROR,
    invalidated: invalidated,
    loading: loading
  });
};

export default withScrollToTop(ProjectDetailPage);